import React, { FC, useMemo } from 'react';
import { AuthContext, AuthContextType } from '@devsbb/dashboard-ui';
import { connect } from 'react-redux';
import { UserType } from 'ggApp/types/graphql';

import { User, user as userSelector } from 'ggApp/modules/auth/selectors';
import { ActiveStore, storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';

type EnhancedProps = {
    user: User;
    store: ActiveStore;
};

const userTypeKeymap = {
    normal_customer: UserType.PERSONAL,
    business_customer: UserType.BUSINESS,
};

// Provider component that provides mapped data from redux user state to graphql user data
// We use this implementation to avoid unnecessary request to graphql to fetch user data
const DashboardAuthProvider: FC<EnhancedProps> = ({ user, store, children }) => {
    const auth = useMemo<AuthContextType>(() => {
        return {
            user: {
                id: user?.id,
                firstName: user?.first_name,
                lastName: user?.last_name,
                type: userTypeKeymap[user?.user_type ?? ''],
                email: user?.email,
                phone: user?.phone,
            },
            store: {
                id: store?.store_id,
                code: store?.code,
                storeType: store?.store_type?.toLowerCase(),
                defaultLocale: store?.default_language,
                alternativeLocales: store?.languages,
            },
            logout: () => {},
        };
    }, [user, store]);

    return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

const enhance = connect<EnhancedProps, {}, {}>((state) => ({
    user: userSelector(state),
    store: activeStoreSelector(state),
}));

export default enhance(DashboardAuthProvider);
